export interface IMonitorState {
    isLoading: boolean;
    monitorData: IMonitorResponse[];
}

export const REQUEST_MONITORS = "REQUEST_MONITORS";
export const RECEIVE_MONITORS = "RECEIVE_MONITORS";

export interface IRequesMonitorsAction {
    type: typeof REQUEST_MONITORS;
}

export interface IReceiveMonitorsAction {
    type: typeof RECEIVE_MONITORS;
    monitorData: IMonitorResponse[];
}

export type MonitorTypes = IRequesMonitorsAction | IReceiveMonitorsAction;

export interface IMonitorResponse {
    id: string;
    name: string;
    "resource-name": string;
    detail: string;
    active: boolean;
    category: string;
    type: string;
    personalInfo: string;
    "order-num": string;
    maxType: string;
    nickname: string;
    message: string;
    "account-information": string;
    "fastlink-url": string;
}
